// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"2f7627fd1a9fa71fbc8d","691":"e8e7e3dd3eccda9b32a8"}[chunkId] + ".js";
};